
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/ai-and-agents/tool-approval",
      function () {
        return require("private-next-pages/x/react-chat/ai-and-agents/tool-approval.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/ai-and-agents/tool-approval"])
      });
    }
  